import React from 'react'
import { Breadcrumbs, MetaSeo, Trans } from '../../../components/index'
import useTrans from '../../../hooks/useTrans'
import { getAltText } from '../../../utils/safe'

const TecnicheStampaTemplate = ({ page, tecnicheData }) => {
  const t = useTrans()
  return (
    <div className="page">
      <div className="tecniche-stampa">
        <div className="w-container">
          <MetaSeo seo={page.seo} />
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          <h1 className="page__title">
            <Trans chiave="Tecniche di stampa" />
          </h1>
        </div>

        <div className="tecniche-stampa__header">
          <div className="tecniche-stampa-header">
            <div className="tecniche-stampa-header__content">
              <p className="tecniche-stampa-header__title">
                <Trans chiave="Le nostre tecniche" />
              </p>
              <div
                className="tecniche-stampa-header__description"
                dangerouslySetInnerHTML={{
                  __html: t(
                    'Offriamo un servizio completo per la personalizzazione dei prodotti, con tempistiche di stampa veloci e affidabili.<br />Scopri le tecniche di stampa che adottiamo'
                  ),
                }}
              ></div>
            </div>
            <div className="tecniche-stampa-header__list">
              {tecnicheData &&
                tecnicheData.map((item) => {
                  return (
                    <div className="tecniche-stampa-header__item">
                      <div className="tecniche-stampa-header__item-icon-box">
                        <img src={item.icon?.url} alt={getAltText(item.icon) || item.nome} title={item.nome} />
                      </div>
                      <p className="tecniche-stampa-header__item-title">{item.nome}</p>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>

        <div className="w-container">
          <div className="tecniche-stampa__list">
            {tecnicheData &&
              tecnicheData.map((item) => {
                return (
                  <div className="tecniche-stampa-box">
                    <div className="tecniche-stampa-box__head">
                      <div className="tecniche-stampa-box__icon-box">
                        <img src={item.icon?.url} alt={getAltText(item.icon) || item.nome} title={item.nome} />
                      </div>
                      <p className="tecniche-stampa-box__title">{item.nome}</p>
                    </div>
                    <div className="tecniche-stampa-box__main">
                      <div className="tecniche-stampa-box__image-box">
                        <img src={item.image?.url} alt={getAltText(item.image) || item.nome} title={item.nome} />
                      </div>
                      <div
                        className="tecniche-stampa-box__content"
                        dangerouslySetInnerHTML={{
                          __html: item.descrizione,
                        }}
                      ></div>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TecnicheStampaTemplate
